export const defaultOrderBy = 'Name';

// TODO: Remove the nonsortable properties when ready to support
const defaultConfigsWithoutExtraData = [
  { id: 'name', width: 150 },
  { id: 'email', width: 200 },
  { id: 'phone', width: 150 },
  { id: 'city', width: 168 },
  { id: 'state', width: 100 },
  { id: 'country', width: 100 },
  { id: 'company', width: 150 },
  { id: 'marketplaces', width: 180, nonsortable: true },
  { id: 'marketplace-usernames', width: 200, nonsortable: true },
  { id: 'tags', width: 100, nonsortable: true },
];

export const baseColumnsDefaultConfigs = defaultConfigsWithoutExtraData.map((column, index) => {
  return {
    ...column,
    minWidth: 70,
    index,
    pinned: false,
  };
});

export const defaultColumnConfigurations = [...baseColumnsDefaultConfigs];
